import { render, staticRenderFns } from "./cancelamento_detalhe.vue?vue&type=template&id=cad43392&scoped=true"
import script from "./cancelamento_detalhe.vue?vue&type=script&lang=js"
export * from "./cancelamento_detalhe.vue?vue&type=script&lang=js"
import style0 from "./cancelamento_detalhe.vue?vue&type=style&index=0&id=cad43392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad43392",
  null
  
)

export default component.exports